var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("step-1"),_vm._v(" "),(_vm.step > 1)?_vm._t("step-2"):_vm._e(),_vm._v(" "),(_vm.step > 2)?_vm._t("step-3"):_vm._e(),_vm._v(" "),(_vm.step > 3)?_vm._t("step-4"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }